// ./Pages/CreatePage/CreatePage.js
import React, { useState } from "react";
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { create } from "../../WebApi";

const Root = styled.div`
  width: 80%;
  margin: 0 auto;
`;

const Title = styled.div`
  padding: 5px 0;
  input {
    width: 100%;
  }

  div {
    padding-bottom: 5px;
  }
`;

const Content = styled.div`
  padding-bottom: 10px;
  
  textarea {
    width: 100%;
  }

  div {
    padding-bottom: 5px;
  }
`;

const ErrorMessage = styled.div`
  color: red;
`;


export default function CreatePage() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  const history = useHistory(); 

  const handleSubmit = e => {
    e.preventDefault();
    create(title, content).then( data => {
      console.log(data);
      if (data.ok === 0) {
        return setErrorMessage(data.message);
      }
      history.push('/');
    });
  };



  return (
    <Root>
      <form onSubmit={handleSubmit}>
        <Title>
          <div>
            Title
          </div>
          <input type="text" value={title} onChange={ e => setTitle(e.target.value)} />
        </Title>
        <Content>
          <div>
            Content
          </div>
          <textarea rows="10" value={content} onChange={ e => setContent(e.target.value)}>
          </textarea>
        </Content>
        <div>
          <button type="submit">新增</button>
        </div>
        { errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </form>
    </Root>
  );
};